export function buildProjectAutomationPayload(draft) {
  if (!draft.sourceRunGuid) throw new Error('请选择已成功交付的手动成果')
  if (!String(draft.name || '').trim() || String(draft.cron || '').trim().split(/\s+/).length !== 5) throw new Error('请填写名称和有效的五段定时规则')
  return { projectGuid: draft.projectGuid, sourceRunGuid: draft.sourceRunGuid, name: String(draft.name).trim(),
    cron: String(draft.cron).trim(), timezone: draft.timezone || 'Asia/Shanghai' }
}

// 单次基础设施故障不等于授权/配置失效，避免运营误认为需要重新建立模板。
export function projectAutomationOutcomeLabel(status) {
  return { queued: '已创建任务', succeeded: '已交付', failed: '失败', cancelled: '已停止',
    skipped_project_busy: '项目已有活动工作，已跳过', skipped_overlap: '上次未完成，已跳过',
    skipped_missed: '错过时点，不补跑', skipped_disabled: '已暂停',
    skipped_service_unavailable: '执行服务暂时不可用，本次已跳过', paused_invalid: '配置失效，已暂停' }[status] || status
}
